import { BasketItem } from "@hermes/api-model-basket";

import {
    MergeInput,
    mergeInputs,
    RequiredKeys,
} from "@hermes/utils-generic-helpers";

import {
    LightProduct,
    productLightDefaults,
} from "../models/basket-feature.model";

export const isBasketItemEngraving = (item: BasketItem): boolean =>
    Boolean(item.customOptions?.engraving?.length);

export function lightProductFromProduct<
    INPUTS extends MergeInput<
        Omit<LightProduct, RequiredKeys<typeof productLightDefaults>>
    >,
>(...inputs: INPUTS): LightProduct {
    return mergeInputs<LightProduct>(productLightDefaults, ...inputs);
}

export function isLightProductInStock(product: LightProduct): boolean {
    return typeof product.stock === "boolean"
        ? product.stock
        : !!(product.stock?.ecom || product.stock?.shared);
}
